<template>
  <div class="full-height">
    <el-container>
      <el-header>
        <div class="htopbox">
          <div class="title-box">
            <span>{{ $t("message.menu.title") }}
              <span style="color:#fb5a5e;font-size:13px;">{{ $t('messageAdd.mainPage.versionMsg') }} <el-link :underline="false" type="primary" style="font-size:13px;" href="https://cdn.iot.seuic.com/QuickConfig" target="_blank">{{ $t('messageAdd.mainPage.oldVersion') }}</el-link></span>
            </span>
            <div>
              <!-- 切换中英文 -->
              <span class="help-title">
              <change-lang></change-lang>
              </span>
              <!-- 查看帮助 -->
              <span class="help-title" @click="openHelpDialog"
                >
                <svg-icon icon-class="help"/>
                {{ $t("message.menu.help") }}</span
              >
              <!-- 登录 (非私有化 + 未登录) -->
              <span class="help-title" v-if="!isPrivate && !isLogin" @click="login">
                <svg-icon icon-class="admin"/>
                {{ $t('messageAdd.mainPage.login') }}</span
              >
              <!-- 登出 (非私有化 + 已登录) -->
              <span class="help-title" v-if="!isPrivate && isLogin" @click="userlogout">
                <svg-icon icon-class="admin"/>
                {{ $t('messageAdd.mainPage.unlogin') }}</span
              >
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <!-- 菜单栏 -->
        <el-aside width="300px">
          <div class="menu-fullBox">
          <span class="menu-secTitle">{{ $t('messageAdd.mainPage.001') }}</span>
            <div class="menu-box"  :class="{ active: selected === m.name }" 
              v-for="m in menuList" :key="m.name" @click="selectMenu(m.name,m)"> 
              <i :class="[m.icon, { 'icon-active': selected === m.name }]"></i>
              <span>{{ m.name }}</span>
              <div class="lock-wrapper" v-if="isLock && m.path !== '/common'">
                  <div class="gray-rectangle">
                     <svg-icon icon-class="lock" class="lockStyle"/>
                  </div>
              </div>
            </div>
            <span class="menu-secTitle">{{ $t('messageAdd.mainPage.002') }}</span>
            <div class="menu-box"  :class="{ active: selected === m.name }" 
           v-for="m in menuList2" :key="m.name"  @click="selectMenu(m.name,m)" > 
              <i :class="[m.icon, { 'icon-active': selected === m.name }]"></i>
              <span>{{ m.name }}</span>
              <div class="lock-wrapper" v-if="isLock">
                  <div class="gray-rectangle">
                     <svg-icon icon-class="lock" class="lockStyle"/>
                  </div>
              </div>
            </div>
          </div>
        </el-aside>
        <el-container>
          <el-main>
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <!-- 帮助弹框 -->
    <el-dialog
      :title="$t('message.messageMsg.helpTitle')"
      :visible.sync="helpDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <p>{{ $t('message.messageMsg.help1') }}</p>
      <p>{{ $t('message.messageMsg.help2') }}</p>
      <p>{{ $t('message.messageMsg.help3') }}</p>
      <p>{{ $t('message.messageMsg.help4') }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="helpDialogVisible = false">{{
          $t('message.messageMsg.close')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { logout } from '@/api/user';
import changeLang from '@/components/changeLang.vue';
import { isPrivate } from '@/config';
import { errorInfo, successInfo } from '@/utils/common';
import Cookies from "js-cookie";
import { toSSOLogin } from '@/api/utils';
export default {
  components: { changeLang },
  data() {
    return {
      isPrivate,
      helpDialogVisible:false,
      selected: '', // 用来存储当前选中的菜单项的名称
    };
  },
  computed:{
    menuList(){
      return [
        {
          name:this.$t('messageAdd.mainPage.003'),
          icon:"el-icon-s-tools",
          path:"/common"
        },
        {
          name:this.$t('messageAdd.mainPage.004'),
          icon:"el-icon-s-release",
          path:"/DeactSysFunction",
        },
        {
          name:this.$t('messageAdd.mainPage.005'),
          icon:"el-icon-s-help",
          path:"/CustomConfigMode",
        }
      ]
    },
    menuList2(){
      return [
        {
          name:this.$t('messageAdd.mainPage.006'),
          icon:"el-icon-s-order",
          path:"/SaveConfigScheme",
        }
      ]
    },
    isLock() {
      return !isPrivate && !Cookies.get('JSESSIONID_StageNow')
    },
    isLogin() {
      return Cookies.get('JSESSIONID_StageNow')
    }
  },
  watch:{
    '$route'(to, from) {
      // 当路由变化时，更新selected状态
      const menuItems = [...this.menuList, ...this.menuList2];
      const foundItem = menuItems.find(item => item.path === to.path);
      if (foundItem) {
        this.selected = foundItem.name;
      } else if (to.name === 'CustomConfigModeChildPage') {
        // 特殊处理CustomConfigModeChildPage路由
        this.selected = 'CustomConfigMode';
      } else {
        this.selected = null;
      }
    }
  },
  methods: {
    goPage(url){
      this.$router.push({path:url})
    },
    openHelpDialog() {
      this.helpDialogVisible = true;
    },
    selectMenu(name,m) {
      this.selected = name; // 更新选中的名称
      this.goPage(m.path);
    },
    // 登录
    login() {
      return toSSOLogin();
    },
    // 登出
    userlogout() {
      logout().then(res => {
        if(res.success) {
          successInfo('common.logout_success');
          Cookies.remove('JSESSIONID_StageNow');
          localStorage.removeItem('__IOT_URL__'); // 删除ioturl
          localStorage.removeItem('__USER_INFO__'); // 删除用户信息
          return toSSOLogin({type: 'logout'});
        }else{
          console.log("登出失败",res);
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.full-height {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-container {
  flex: 1; // 让 el-container 占据剩余空间
  display: flex;
  //flex-direction: row;
}

.el-header {
  background-color: #464c5b;
  color: #fff; // 通常使用白色来对比深色背景
  text-align: center;
  height: 60px;
  line-height: 60px; // 垂直居中
}

.el-aside {
  text-align: center;
  border-right: 1px solid #e9e9e9;
  width: 300px; // 固定宽度
  flex-shrink: 0; // 不收缩
}

.el-main {
  height:calc(100vh - 60px);
  overflow-y: auto; // 允许垂直滚动
  padding: 0; // 根据需要添加内边距
}

.htopbox {
  height: 60px;
  color: white;
  background-color: #464c5b;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      display: inline-block;
      font-size: 24px;
    }

    .help-title {
      font-size: 16px;
      margin-right: 20px;
      color: white;
      cursor: pointer;
    }
  }
}
.menu-fullBox{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .menu-secTitle{
    display: inline-block;
    text-align: left;
    color: #0074c1;
    margin:5px 0;
    margin-left:10px;
  }
  .menu-box{
  margin-left:10px;
  padding: 0 0 0 20px;
  border: 2px solid #ededed;
  border-radius: 5px;
  width:250px;
  height: 60px;
  color: #4a5158;
  font-size: 18px;
  line-height: 60px;
  text-align: left;
  margin-top: 8px;
  overflow: hidden; /* 确保超出部分被隐藏 */
  position: relative; /* 确保锁图标的定位是相对于菜单项的 */

  span{
    margin-left: 20px;
  }
  i{
    font-size: 20px;
    font-weight: bold;
  }
}
.menu-box.active {
  border:1px solid #409eff; /* 外边框变为蓝色 */
}
.icon-active {
  color: #0074c1; /* 图标变为蓝色 */
}

}
.lock-wrapper {
    position: relative;
    top: -66%;
    left: 140px;
    transform: translateY(-50%) rotate(45deg);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden; /* 确保超出部分被隐藏 */
    width: 200px; /* 你可以根据需要调整这个大小 */
    height: 25px;
}

.gray-rectangle {
    background-color:#e9e9e9;
    width: 100%;
    height: 140%;
    z-index: -1; /* 将锁图标置于长方形之上 */
    font-size: 16px;
    color: #808695;
}
.lockStyle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-74%, -54%) rotate(-45deg);
}
</style>
